import { render, staticRenderFns } from "./LoanAuthorizationItems.vue?vue&type=template&id=1679c20a"
import script from "./LoanAuthorizationItems.vue?vue&type=script&lang=js"
export * from "./LoanAuthorizationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports